export default __webpack_public_path__ + "static/media/26.0dcb0201.jpg";